import React from 'react';
import { Globe } from 'lucide-react';
const languages = [{
  code: 'en',
  label: 'English',
  flag: '🇺🇸',
  greeting: 'Welcome'
}, {
  code: 'es',
  label: 'Español',
  flag: '🇲🇽',
  greeting: 'Bienvenido'
}, {
  code: 'zh-CN',
  label: '中文 Chinese',
  flag: '🇨🇳',
  greeting: '欢迎'
}, {
  code: 'tl',
  label: 'Tagalog',
  flag: '🇵🇭',
  greeting: 'Maligayang pagdating'
}, {
  code: 'hy',
  label: 'Հայերեն Armenian',
  flag: '🇦🇲',
  greeting: 'Բարի գալուստ'
}];
interface LanguageSelectorProps {
  onSelect: (code: string) => void;
}
export function LanguageSelector({
  onSelect
}: LanguageSelectorProps) {
  const handleLanguageSelect = (code: string) => {
    // Guardar en sessionStorage para que no vuelva a salir el popup en esta sesión
    sessionStorage.setItem('languageSelected', 'true');
    // Función para forzar la traducción interactuando directamente con el DOM de Google
    const triggerTranslation = () => {
      const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
      if (select) {
        select.value = code;
        select.dispatchEvent(new Event('change'));
        return true;
      }
      return false;
    };
    // Intentar traducir inmediatamente
    if (!triggerTranslation()) {
      // Si el script de Google aún no ha cargado, buscar el elemento cada 200ms
      const interval = setInterval(() => {
        if (triggerTranslation()) {
          clearInterval(interval);
        }
      }, 200);
      // Detener la búsqueda después de 5 segundos por seguridad
      setTimeout(() => clearInterval(interval), 5000);
    }
    // Cerrar el popup inmediatamente para una experiencia fluida
    onSelect(code);
  };
  return <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-charcoal/70 backdrop-blur-sm px-4" data-id="element-190">
      <div className="bg-white rounded-3xl shadow-2xl max-w-lg w-full overflow-hidden border border-gray-100" data-id="element-191">
        {/* Header */}
        <div className="bg-sylmar-light px-8 pt-8 pb-6 text-center" data-id="element-192">
          <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-md" data-id="element-193">
            <Globe className="w-8 h-8 text-sylmar" data-id="element-194" />
          </div>
          <h2 className="text-2xl font-bold text-charcoal mb-1" data-id="element-195">
            Select Your Language
          </h2>
          <p className="text-charcoal-light text-sm" data-id="element-196">
            Selecciona tu idioma preferido
          </p>
        </div>

        {/* Language Buttons */}
        <div className="p-6 space-y-3" data-id="element-197">
          {languages.map(lang => <button key={lang.code} onClick={() => handleLanguageSelect(lang.code)} className="w-full flex items-center gap-4 px-5 py-4 rounded-xl border-2 border-gray-100 hover:border-sylmar hover:bg-sylmar-light transition-all duration-200 group text-left" data-id="element-198">
              <span className="text-3xl flex-shrink-0" data-id="element-199">{lang.flag}</span>
              <div className="flex-grow" data-id="element-200">
                <span className="font-bold text-charcoal group-hover:text-sylmar transition-colors text-lg" data-id="element-201">
                  {lang.label}
                </span>
                <span className="block text-xs text-gray-400 group-hover:text-sylmar-dark transition-colors" data-id="element-202">
                  {lang.greeting}
                </span>
              </div>
              <span className="text-gray-300 group-hover:text-sylmar transition-colors text-xl" data-id="element-203">
                →
              </span>
            </button>)}
        </div>

        {/* Footer */}
        <div className="px-8 pb-6 text-center" data-id="element-204">
          <p className="text-xs text-gray-400" data-id="element-205">
            Sylmar Neighborhood Council · Concilio Vecinal de Sylmar
          </p>
        </div>
      </div>
    </div>;
}